import { render, staticRenderFns } from "./CategoriesGroup.vue?vue&type=template&id=48a167ca&scoped=true&"
import script from "./CategoriesGroup.vue?vue&type=script&lang=js&"
export * from "./CategoriesGroup.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesGroup.vue?vue&type=style&index=0&id=48a167ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a167ca",
  null
  
)

export default component.exports